import { app } from '../../../../app';
import { Controller } from './edit-sms-settings.controller';

app.component('editCorporateSmsSettings', {
    bindings: {close: '&', dismiss: '&', resolve: '<'},
    controller: Controller,
    templateUrl: require('./edit-sms-settings.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/sms-services/edit-sms-settings/edit-sms-settings.component.js